/**
 * To support scripts that use this environment outside of next commands,
 * we need to load the env files using their lib. loadEnvConfig is loading
 * from the filesystem, so if we aren't on the server, we can't call this.
 */
if (typeof window === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { loadEnvConfig } = require('@next/env');
  loadEnvConfig(process.cwd());
}

export const Environment = {
  ApiBase: process.env.NEXT_PUBLIC_API_BASE,
  BasisTheory: process.env.NEXT_PUBLIC_BT_API_KEY,
  Stripe: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  ForceScreeningManualApproval: process.env.NEXT_PUBLIC_FORCE_SCREENING_MANUAL_APPROVAL,
  GoogleMaps: process.env.NEXT_PUBLIC_GMAPS_API_KEY,
  DataDog: {
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE || 'datadoghq.com',
    env: process.env.NEXT_PUBLIC_DATADOG_ENV || 'development',
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE || 'frontend-3d',
  },
};
